// extracted by mini-css-extract-plugin
export default {"productGrid":"u2-z","centerLink":"v2-z","productSection":"w2-z","item":"x2-z","ctaButton":"y2-z"};